import { render, staticRenderFns } from "./BrowseBuildingNobemen.vue?vue&type=template&id=2156a33b&scoped=true&"
import script from "./BrowseBuildingNobemen.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingNobemen.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingNobemen.vue?vue&type=style&index=0&id=2156a33b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156a33b",
  null
  
)

export default component.exports